import { elementConstants } from "../../../../../constants/cms/form/element/element.constants";
import { deepClone, checkForUpdatesOneLevel } from "../../../../../helpers/objectHelper";
import { elementOrgin } from "../../../../../cms/helpers/elementHelper";

const initialState = {};

export function element(state = initialState, action) {
  switch (action.type) {
    case elementConstants.GETALL_ELEMENTS_REQUEST:
      return {
        loading: true
      };
    case elementConstants.GETALL_ELEMENTS_SUCCESS:
      const elements = Array.from(action.elements);
      const newElements = elements.map(el => {
        let newEl = deepClone(el);
        newEl.formId = -1;
        newEl.data = elementOrgin(newEl.type);
        newEl.formElementId = -1;
        return newEl;
      })
      return {
        loading: false,
        elements: newElements
      };
    case elementConstants.GETALL_ELEMENTS_FAILURE:
      return {
        loading: false,
        error: action.error
      };
    case elementConstants.UPDATE_ELEMENT_REQUEST:
      return {
        ...state,
        id: action.id,
        loading: true
      };
    case elementConstants.UPDATE_ELEMENT_SUCCESS:
      return {
        ...state,
        updatedElement: action.element,
        loading: false
      };
    case elementConstants.UPDATE_ELEMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case elementConstants.CREATE_ELEMENT_REQUEST:
      return {
        ...state,
        loading: true
      };
    case elementConstants.CREATE_ELEMENT_SUCCESS:
      return {
        ...state,
        loading: false
      };
    case elementConstants.CREATE_ELEMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case elementConstants.ADD_TO_LIST_SUCCESS:
      return {
        ...state,
        elements: [
          ...state.elements,
          action.element
        ]
      };
    case elementConstants.UPDATE_LIST_SUCCESS:
      return {
        ...state,
        elements: action.elements
      };
    case elementConstants.ADD_TO_LIST_SUCCESS:
      const reInsertedElement = deepClone(action.element);
      reInsertedElement.formId = -1;
      reInsertedElement.page = 0;
      reInsertedElement.sortOrder = 0;
      reInsertedElement.data = elementOrgin(reInsertedElement.type);

      return {
        ...state,
        elements: [...state.elements, reInsertedElement]
      };

    default:
      return state;
  }
}
